import React, { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseServices from "Hooks/UseServices";

export const AppConfigContext = React.createContext({
  loadingConfig: false,
  appConfig: {},
});

const AppConfigProvider = ({ children }) => {
  const { api } = UseServices();

  const [loading, setLoading] = useState(false);
  const [appConfig, setAppConfig] = useState({});

  useEffect(() => {
    getAppConfig();
    //eslint-disable-next-line
  }, []);

  const getAppConfig = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("sessions/get-app-config");
      setAppConfig(data.app_config);
    } catch (error) {
      HTTPErrorCallback(error);
    }
    setLoading(false);
  };

  const contextValue = {
    loadingConfig: loading,
    appConfig,
  };

  return (
    <>
      <AppConfigContext.Provider value={contextValue}>
        {children}
      </AppConfigContext.Provider>
    </>
  );
};

export default AppConfigProvider;
